export default function scrollSnapSlider() {

    document.addEventListener('click', (e) => {
        if (e.target.classList.contains('btn-prev') || e.target.classList.contains('btn-next')){

            const scroller = e.target.parentElement.querySelector('.scrollsnap-slider-scroll'),
            scrollSize = e.target.parentElement.querySelector('a').clientWidth;


            if (e.target.classList.contains('btn-prev')){

                scroller.scrollBy(-scrollSize, 0);

            }else{

                scroller.scrollBy(scrollSize, 0);

            }


        }
    })

}
